import React, { useState, useEffect } from "react";
import MainTable from "../../../components/Table/PaginationTable.js";
import { useNavigate } from "react-router-dom";
import {
  CategoriesColumnDefDefaultFnC,
  FestvaliColumnDefDefaultFnC,
} from "./columns/columnDef.js";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchFestivals,
  deleteFestivalById,
} from "../../../redux/festivalSlice.js";
import FileOutlineIcon from "@mui/icons-material/Description";
import { useTranslation } from "react-i18next";
import DownloadButton from "../../../components/common components/DownloadButton.js";
import FilterPanel from "../../../components/common components/FilterPanel.js";
import dayjs from "dayjs";
import WarningShipmentModalComponent from "../../../components/Modals/WarningShipmentModalComponent.js";
import { Menu, MenuItem, Button } from "@mui/material";

const Festival = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const tableData = useSelector((state) => state.festival.festivalData) || [];
  const [pageNumber, setPageNumber] = useState(1);
  const [fileterCriteria, setFilterCriteria] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const totalRecords = 1000;
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState("");
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [isFilterPanelOpen, setIsFilterPanelOpen] = useState(false);

  useEffect(() => {
    dispatch(fetchFestivals());
  }, [dispatch, pageSize, pageNumber]);

  const handleFilter = (criteria) => {
    const formattedCriteria = {
      search: criteria.search,
      startDate: criteria.startDate
        ? dayjs(criteria.startDate).format("YYYY-MM-DD")
        : "",
      endDate: criteria.endDate
        ? dayjs(criteria.endDate).format("YYYY-MM-DD")
        : "",
    };
    setFilterCriteria(formattedCriteria);
    dispatch(fetchFestivals());
  };

  const handleCreateFestival = () => {
    navigate("/create-festival");
  };

  const onPageIndexChange = (newPageIndex) => {
    setPageNumber(newPageIndex);
  };

  const onPageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1); // Reset to the first page when page size changes
  };

  const onDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const deleteFestivalFunction = () => {
    dispatch(deleteFestivalById(deleteCategory))
      .then(() => {
        dispatch(fetchFestivals());
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
      });
    onDeleteModalClose();
  };

  const navigateCallback = (festivalId) => {
    navigate(`/view-festival-details/${festivalId}`);
  };

  // const editCategoryFunction = (companyBuId) => {
  //   navigate(`/edit-product-category/${companyBuId}`);
  // };

  const onDeleteButtonClick = (festivalId, action) => {
    // console.log("id=====>", festivalId, action);
    setIsDeleteModalOpen(true);
    setDeleteCategory(festivalId);
  };

  const columnDef = FestvaliColumnDefDefaultFnC(
    navigateCallback,
    onDeleteButtonClick,
    t
  );

  return (
    <>
      <div className="btn-box py-3">
        <div className="d-flex justify-content-between">
          <Button
            className="btn btn-primary greeen-btn"
            onClick={handleCreateFestival}
          >
            <i className="mdi mdi-plus-circle-outline"></i>{" "}
            {t("orderOutboxcomponents.createNew")}
          </Button>
          <div>
            <Button
              aria-controls="export-menu"
              aria-haspopup="true"
              onClick={handleClick}
              style={{ backgroundColor: "#6AA13C" }}
              className="btn btn-primary greeen-btn m-2"
            >
              <FileOutlineIcon /> Export
            </Button>
            <Menu
              id="export-menu"
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
            >
              <MenuItem onClick={handleClose}>
                {/* <DownloadButton
                  data={tableData}
                  filename="Categories.xlsx"
                  sheetname="Categories"
                  forModule="Categories"
                /> */}
              </MenuItem>
            </Menu>
            <Button
              className="btn btn-light grey-btn"
              onClick={() => setIsFilterPanelOpen((prevState) => !prevState)}
            >
              <i className="bi bi-funnel"></i>{" "}
              {t("orderOutboxcomponents.filters")}
            </Button>
          </div>
        </div>
      </div>

      {isFilterPanelOpen && (
        <FilterPanel
          className="mb-3"
          onFilter={handleFilter}
          onReset={() => dispatch(fetchFestivals())}
        />
      )}

      <MainTable
        columns={columnDef}
        data={tableData}
        initialPageSize={pageSize}
        pageNumber={pageNumber}
        onPageIndexChange={onPageIndexChange}
        onPageSizeChange={onPageSizeChange}
        enablePagination={true}
        totalRecords={totalRecords}
      />

      {isDeleteModalOpen && (
        <WarningShipmentModalComponent
          isOpen={isDeleteModalOpen}
          onClose={onDeleteModalClose}
          handleDelete={deleteFestivalFunction}
        />
      )}
    </>
  );
};

export default Festival;
